import * as React from "react";
import { Table, Button } from "react-bootstrap";
import { firestore } from "firebase";
import * as fs from "../firestore";
import moment from "moment";
import { StatusTypeIndexLabelMap } from "../DeviceTableLabel"

export type DeviceList = fs.DeviceList & {id: string, warrantyStartDate: string};
export type Warranty = fs.Warranty;

interface Props {
    DeviceList: DeviceList[];
    onDeviceLinkClicked: (id: string, SerialNo: string, BluetoothAddress: string, DevStatus: string) => void;
}

export default class DeviceListTable extends React.Component<Props, {}> {

    formatTimestamp(timestamp: firestore.Timestamp): string {
        return moment(timestamp.toDate()).format("YYYY年MM月DD日 HH:mm:ss");
    }

    render() {
        return (
            <div style={{overflowX: "auto"}}>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>機器更新用ID</th>
                            <th>シリアルナンバー</th>
                            <th>Bluetoothアドレス</th>
                            <th>ステータス</th>
                            <th>保証開始日</th>
                            <th>データ作成日時</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.DeviceList.map((result, index) => {
                            return (
                                <tr key={index}>
                                    <td align="center">
                                        <Button variant="link" onClick={() => this.props.onDeviceLinkClicked(result.id,result.SerialNo,result.BluetoothAddress,result.Status)}>
                                        {result.id}
                                        </Button>
                                    </td>
                                    <td align="center">
                                        <Button variant="link" onClick={() => this.props.onDeviceLinkClicked(result.id,result.SerialNo,result.BluetoothAddress,result.Status)}>
                                        {result.SerialNo}
                                        </Button>
                                    </td>
                                    <td align="center">
                                        <Button variant="link" onClick={() => this.props.onDeviceLinkClicked(result.id,result.SerialNo,result.BluetoothAddress,result.Status)}>
                                        {result.BluetoothAddress}
                                        </Button>
                                    </td>
                                    <td align="center">
                                        <Button variant="link" onClick={() => this.props.onDeviceLinkClicked(result.id,result.SerialNo,result.BluetoothAddress,result.Status)}>
                                        {StatusTypeIndexLabelMap[result.Status]}
                                        </Button>
                                    </td>
                                    <td align="center">
                                        {result.warrantyStartDate}
                                    </td>
                                    <td align="center">
                                        {this.formatTimestamp(result.CreateDateTime)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}

